/**
 * Generated by orval v8.1.0 🍺
 * Do not edit manually.
 * RepeatMD.AdminApp, Version=1.0.0.0, Culture=neutral, PublicKeyToken=null
 * OpenAPI spec version: 1.0
 */
import {
  useMutation,
  useQuery
} from '@tanstack/react-query';
import type {
  MutationFunction,
  QueryFunction,
  QueryKey,
  UseMutationOptions,
  UseMutationResult,
  UseQueryOptions,
  UseQueryResult
} from '@tanstack/react-query';

import type {
  AnalyticsExportLinkResponse,
  CreateAnalyticsExportLinkModel,
  MintAdminMcpTokenForVerifiedEmailModel,
  MintAdminMcpTokenModel,
  MintAdminMcpTokenResponse,
  MintMcpAccessTokenForVerifiedAdminEmailResult,
  ProblemDetails,
  RefreshAdminMcpTokenModel,
  RetrievePagedInvocationsParams
} from '.././model';

import { customAxios } from '../../custom-axios';
import type { ErrorType } from '../../custom-axios';




/**
 * @summary Retrieves a paged list of MCP tool invocations recorded for the specified platform, optionally filtered by outcome.
 */
export const retrievePagedInvocations = (
    platformId: string,
    params?: RetrievePagedInvocationsParams,
 signal?: AbortSignal
) => {
      
      
      return customAxios<void>(
      {url: `/api/v1/platforms/${platformId}/mcp/invocations`, method: 'GET',
        params, signal
    },
      );
    }
  



export const getRetrievePagedInvocationsQueryKey = (platformId: string,
    params?: RetrievePagedInvocationsParams,) => {
    return [
    `/api/v1/platforms/${platformId}/mcp/invocations`, ...(params ? [params] : [])
    ] as const;
    }

    
export const getRetrievePagedInvocationsQueryOptions = <TData = Awaited<ReturnType<typeof retrievePagedInvocations>>, TError = ErrorType<unknown>>(platformId: string,
    params?: RetrievePagedInvocationsParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof retrievePagedInvocations>>, TError, TData>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getRetrievePagedInvocationsQueryKey(platformId,params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof retrievePagedInvocations>>> = ({ signal }) => retrievePagedInvocations(platformId,params, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(platformId), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof retrievePagedInvocations>>, TError, TData> & { queryKey: QueryKey }
}

export type RetrievePagedInvocationsQueryResult = NonNullable<Awaited<ReturnType<typeof retrievePagedInvocations>>>
export type RetrievePagedInvocationsQueryError = ErrorType<unknown>


/**
 * @summary Retrieves a paged list of MCP tool invocations recorded for the specified platform, optionally filtered by outcome.
 */

export function useRetrievePagedInvocations<TData = Awaited<ReturnType<typeof retrievePagedInvocations>>, TError = ErrorType<unknown>>(
 platformId: string,
    params?: RetrievePagedInvocationsParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof retrievePagedInvocations>>, TError, TData>, }
  
 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getRetrievePagedInvocationsQueryOptions(platformId,params,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  return { ...query, queryKey: queryOptions.queryKey };
}




/**
 * @summary Mints an MCP access token for the authenticated admin user scoped to the specified platform.
 */
export const mintToken = (
    mintAdminMcpTokenModel: MintAdminMcpTokenModel,
 signal?: AbortSignal
) => {
      
      
      return customAxios<MintAdminMcpTokenResponse>(
      {url: `/api/v1/mcp/auth/token`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: mintAdminMcpTokenModel, signal
    },
      );
    }
  


export const getMintTokenMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof mintToken>>, TError,{data: MintAdminMcpTokenModel}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof mintToken>>, TError,{data: MintAdminMcpTokenModel}, TContext> => {

const mutationKey = ['mintToken'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof mintToken>>, {data: MintAdminMcpTokenModel}> = (props) => {
          const {data} = props ?? {};

          return  mintToken(data,)
        }



        


  return  { mutationFn, ...mutationOptions }}

    export type MintTokenMutationResult = NonNullable<Awaited<ReturnType<typeof mintToken>>>
    export type MintTokenMutationBody = MintAdminMcpTokenModel
    export type MintTokenMutationError = ErrorType<unknown>

    /**
 * @summary Mints an MCP access token for the authenticated admin user scoped to the specified platform.
 */
export const useMintToken = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof mintToken>>, TError,{data: MintAdminMcpTokenModel}, TContext>, }
 ): UseMutationResult<
        Awaited<ReturnType<typeof mintToken>>,
        TError,
        {data: MintAdminMcpTokenModel},
        TContext
      > => {
      return useMutation(getMintTokenMutationOptions(options));
    }
    /**
 * @summary Mints an MCP access token for a verified admin email address via the email gateway workspace key, rate-limiting ineligible senders to prevent enumeration.
 */
export const mintTokenForVerifiedEmail = (
    mintAdminMcpTokenForVerifiedEmailModel: MintAdminMcpTokenForVerifiedEmailModel,
 signal?: AbortSignal
) => {
      
      
      return customAxios<MintMcpAccessTokenForVerifiedAdminEmailResult>(
      {url: `/api/v1/mcp/auth/token/mint-for-verified-email`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: mintAdminMcpTokenForVerifiedEmailModel, signal
    },
      );
    }
  


export const getMintTokenForVerifiedEmailMutationOptions = <TError = ErrorType<ProblemDetails>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof mintTokenForVerifiedEmail>>, TError,{data: MintAdminMcpTokenForVerifiedEmailModel}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof mintTokenForVerifiedEmail>>, TError,{data: MintAdminMcpTokenForVerifiedEmailModel}, TContext> => {

const mutationKey = ['mintTokenForVerifiedEmail'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof mintTokenForVerifiedEmail>>, {data: MintAdminMcpTokenForVerifiedEmailModel}> = (props) => {
          const {data} = props ?? {};

          return  mintTokenForVerifiedEmail(data,)
        }



        


  return  { mutationFn, ...mutationOptions }}

    export type MintTokenForVerifiedEmailMutationResult = NonNullable<Awaited<ReturnType<typeof mintTokenForVerifiedEmail>>>
    export type MintTokenForVerifiedEmailMutationBody = MintAdminMcpTokenForVerifiedEmailModel
    export type MintTokenForVerifiedEmailMutationError = ErrorType<ProblemDetails>

    /**
 * @summary Mints an MCP access token for a verified admin email address via the email gateway workspace key, rate-limiting ineligible senders to prevent enumeration.
 */
export const useMintTokenForVerifiedEmail = <TError = ErrorType<ProblemDetails>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof mintTokenForVerifiedEmail>>, TError,{data: MintAdminMcpTokenForVerifiedEmailModel}, TContext>, }
 ): UseMutationResult<
        Awaited<ReturnType<typeof mintTokenForVerifiedEmail>>,
        TError,
        {data: MintAdminMcpTokenForVerifiedEmailModel},
        TContext
      > => {
      return useMutation(getMintTokenForVerifiedEmailMutationOptions(options));
    }
    /**
 * @summary Refreshes an existing MCP access token for the administrator on the platform, enforcing a per-token rate limit.
 */
export const refreshToken = (
    refreshAdminMcpTokenModel: RefreshAdminMcpTokenModel,
 signal?: AbortSignal
) => {
      
      
      return customAxios<MintAdminMcpTokenResponse>(
      {url: `/api/v1/mcp/auth/token/refresh`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: refreshAdminMcpTokenModel, signal
    },
      );
    }
  


export const getRefreshTokenMutationOptions = <TError = ErrorType<ProblemDetails>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof refreshToken>>, TError,{data: RefreshAdminMcpTokenModel}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof refreshToken>>, TError,{data: RefreshAdminMcpTokenModel}, TContext> => {

const mutationKey = ['refreshToken'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof refreshToken>>, {data: RefreshAdminMcpTokenModel}> = (props) => {
          const {data} = props ?? {};

          return  refreshToken(data,)
        }



        


  return  { mutationFn, ...mutationOptions }}

    export type RefreshTokenMutationResult = NonNullable<Awaited<ReturnType<typeof refreshToken>>>
    export type RefreshTokenMutationBody = RefreshAdminMcpTokenModel
    export type RefreshTokenMutationError = ErrorType<ProblemDetails>

    /**
 * @summary Refreshes an existing MCP access token for the administrator on the platform, enforcing a per-token rate limit.
 */
export const useRefreshToken = <TError = ErrorType<ProblemDetails>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof refreshToken>>, TError,{data: RefreshAdminMcpTokenModel}, TContext>, }
 ): UseMutationResult<
        Awaited<ReturnType<typeof refreshToken>>,
        TError,
        {data: RefreshAdminMcpTokenModel},
        TContext
      > => {
      return useMutation(getRefreshTokenMutationOptions(options));
    }
    /**
 * @summary Creates a short-lived analytics export link that maps a protected export token to the authenticated admin and platform.
 */
export const createAnalyticsExportLink = (
    createAnalyticsExportLinkModel: CreateAnalyticsExportLinkModel,
 signal?: AbortSignal
) => {
      
      
      return customAxios<AnalyticsExportLinkResponse>(
      {url: `/api/v1/mcp/auth/analytics-export-links`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: createAnalyticsExportLinkModel, signal
    },
      );
    }
  


export const getCreateAnalyticsExportLinkMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createAnalyticsExportLink>>, TError,{data: CreateAnalyticsExportLinkModel}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof createAnalyticsExportLink>>, TError,{data: CreateAnalyticsExportLinkModel}, TContext> => {

const mutationKey = ['createAnalyticsExportLink'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof createAnalyticsExportLink>>, {data: CreateAnalyticsExportLinkModel}> = (props) => {
          const {data} = props ?? {};

          return  createAnalyticsExportLink(data,)
        }



        


  return  { mutationFn, ...mutationOptions }}

    export type CreateAnalyticsExportLinkMutationResult = NonNullable<Awaited<ReturnType<typeof createAnalyticsExportLink>>>
    export type CreateAnalyticsExportLinkMutationBody = CreateAnalyticsExportLinkModel
    export type CreateAnalyticsExportLinkMutationError = ErrorType<unknown>

    /**
 * @summary Creates a short-lived analytics export link that maps a protected export token to the authenticated admin and platform.
 */
export const useCreateAnalyticsExportLink = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createAnalyticsExportLink>>, TError,{data: CreateAnalyticsExportLinkModel}, TContext>, }
 ): UseMutationResult<
        Awaited<ReturnType<typeof createAnalyticsExportLink>>,
        TError,
        {data: CreateAnalyticsExportLinkModel},
        TContext
      > => {
      return useMutation(getCreateAnalyticsExportLinkMutationOptions(options));
    }
    